import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper, CalendarDays, Globe2, Mail, ArrowRight } from "lucide-react";
import api from "@/lib/api";

function StatCard({ icon: Icon, label, value, sub, to, testid }) {
  return (
    <Link to={to} data-testid={testid}
      className="group rounded-xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:border-ukf-gold hover:shadow-md">
      <div className="flex items-center justify-between">
        <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-ukf-red/10 text-ukf-red"><Icon className="h-5 w-5" /></span>
        <ArrowRight className="h-4 w-4 text-slate-300 transition-transform group-hover:translate-x-1 group-hover:text-ukf-red" />
      </div>
      <p className="mt-4 font-serif text-4xl font-bold text-ukf-ink">{value}</p>
      <p className="text-sm font-medium text-slate-600">{label}</p>
      {sub && <p className="mt-1 text-xs text-slate-400">{sub}</p>}
    </Link>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState({ news: 0, news_published: 0, events: 0, events_published: 0, federations: 0, messages: 0, unread_messages: 0 });

  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-3xl font-bold text-ukf-ink">Dashboard</h1>
      <p className="mt-1 text-sm text-slate-500">Overview of published content.</p>
      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard icon={Newspaper} label="News posts" value={stats.news} sub={`${stats.news_published} published`} to="/admin/news" testid="stat-news" />
        <StatCard icon={CalendarDays} label="Events" value={stats.events} sub={`${stats.events_published} published`} to="/admin/events" testid="stat-events" />
        <StatCard icon={Globe2} label="Federations" value={stats.federations} sub="in directory" to="/admin/federations" testid="stat-federations" />
        <StatCard icon={Mail} label="Messages" value={stats.messages} sub={`${stats.unread_messages} unread`} to="/admin/contact" testid="stat-messages" />
      </div>
    </div>
  );
}
